import {Component, OnInit, ViewChild} from '@angular/core';
import {TabsetComponent} from 'ngx-bootstrap/tabs';
import {WfTableComponent} from '../../../../common/table-sort/wf-table.component';
import {PaginationInstance} from 'ngx-pagination';
import {WebClientConfigurationService} from '../../../../services/configuration/web-client-configuration.service';
import {BpAdministrationService} from '../../../../services/bp-administration.service';
import {OverrideDefinitionType} from '../../../../Models/enum/overrideDefinitionType';
import {BehaviorSubject, Observable} from 'rxjs';
import {map, take, tap} from 'rxjs/operators';
import {Utils} from '../../../../services/utils';
import {GenericModalService} from '../../../../services/generic-modal.service';
import {ScheduleModalComponent} from './schedule-modal/schedule-modal.component';
import {ReportsServiceService} from '../../../../services/reports-service';

@Component({
  selector: 'app-business-process-instance-override',
  templateUrl: './business-process-instance-override.component.html',
  styleUrls: ['./business-process-instance-override.component.css', '../../../../styles/business-process-configuration.css']
})
export class BusinessProcessInstanceOverrideComponent implements OnInit {

  @ViewChild('instanceTabset', { static: false }) instanceTabset: TabsetComponent;
  @ViewChild('dataTableSchedule', { static: false }) dataTableSchedule: WfTableComponent;

  lifeCycles: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  utils = Utils;
  config: PaginationInstance;
  schedules: any[];
  hasSchedules: boolean;
  totalSchedulesListed: number;

  p = 1;
  totalItemsPerPage;
  total: number;
  errorScheduleMessage = '';
  successScheduleMessage = '';
  overrideTypes = [];
  bpList = [];
  lifeCycleList = [];
  isRemoving = false;
  errorMessage = '';

  constructor(private bpAdmService: BpAdministrationService, private webClientConfig: WebClientConfigurationService,
              private modalService: GenericModalService, private reportService: ReportsServiceService) { }

  ngOnInit() {
    this.loadOverrideType();
    this.loadBusinessProcesses();
    this.loadLifeCycles();
    this.getPage(1);
  }

  refreshTabScroll(status: boolean) {
    if (status) {
      this.getPage(this.p);
      this.instanceTabset.tabs[1].active = true;
    }
  }

  loadOverrideType() {
    this.errorMessage = '';
    this.bpAdmService.getOverrideDefinitionTypes().subscribe(r => {
      this.overrideTypes = r;
    }, error1 => this.errorMessage = error1);
  }

  loadBusinessProcesses() {
    this.errorMessage = '';
    this.bpAdmService.getBusinessProcessesOverride().subscribe(res => {
        this.bpList = res;
      },
      error1 => {
        this.errorMessage = error1;
      });
  }

  loadLifeCycles() {
    this.errorMessage = '';
    this.reportService.getStateLifeCyclesForOverride()
      .subscribe(
        result => {
          this.lifeCycles.next(result);
          this.lifeCycleList = result;
        }, error1 => {
          this.errorMessage = error1;
          console.error(error1);
        }
      );
  }

  removeSchedule(item) {
    this.errorScheduleMessage = '';
    item = this.removeExtensionData(item);
    console.log(item);

    let alert: any;
    alert = this.modalService
      .showConfirmModal('Confirmação de exclusão de agendamento', 'Confirma a exclusão do agendamento?');

    alert.then((result) => {
      if (result.value) {
        this.bpAdmService.deleteSchedulingWithOverrideInstance(item)
          .subscribe(s => {
            this.successScheduleMessage = `Agendamento excluído com sucesso.`;
            this.isRemoving = true;
            setTimeout(() => {
              this.successScheduleMessage = '';
              this.refreshTabScroll(true);
            }, 2000);
          }, error1 => {
            this.isRemoving = false;
            this.errorScheduleMessage = error1;
          });
      }
    });
  }

  openSchedulingEditor(item) {
    item = this.removeExtensionData(item);
    item.overrideDefinition.typeDescription = this.overrideTypes
      .filter(f => parseInt(item.overrideDefinition.type, 10) === f.value)
      .map(m => m.translatedName)[0];
    item.overrideDefinition.businessProcessName = this.bpList
      .filter(f => parseFloat(item.overrideDefinition.businessProcessId) === f.businessProcessId)
      .map(m => m.name)[0];

    item.stateLifeCycles = this.lifeCycleList;
    const destComponent: any = ScheduleModalComponent;
    const result$ = this.modalService.showObjModal(destComponent, 'Configurar Agendamento', item);
    if (result$) {
      result$.asObservable()
        .pipe(take(1))
        .subscribe((result) => {
          // devolver para a tela principal, se deve ou nao atualizar a aba de agendamento
          this.refreshTabScroll(result);
        });
    } else {
      this.errorScheduleMessage = 'Erro: Sessão expirada.';
    }
  }

  removeExtensionData(item) {
    delete item['extensionData'];
    delete item['overrideDefinition']['extensionData'];
    delete item['schedulingInfo']['extensionData'];
    return item;
  }

  getPage(pageIndex: number) {

    if (this.totalSchedulesListed == 1 && this.isRemoving) {
      this.isRemoving = false;
      pageIndex -= 1;
    }

    this.errorScheduleMessage = '';

    this.bpAdmService.getPagedOverrideInstanceScheduling(pageIndex)
      .pipe(
        tap( res => {
          this.total = res.total;
          this.p = pageIndex;

          /*this.config  = {
            id: 'pagOverrideInstanceScheduling',
            itemsPerPage: this.totalItemsPerPage,
            currentPage: pageIndex,
            totalItems: res.total
          };*/
          this.getPaginationConfig(pageIndex, res.total);
        }, error1 => {
          this.errorScheduleMessage = error1;
        }),
        map(res => res.items)
      ).subscribe(value => {
        this.schedules = value;
        this.hasSchedules = value.length > 0;
        this.totalSchedulesListed = value.length;
      });

  }


  getPaginationConfig(_currentPage: number, _totalItems: number) {
    this.errorScheduleMessage = '';
    this.webClientConfig.getPageSizeConfig().subscribe(item => {
      this.config  = {
        id: 'server',
        itemsPerPage: item,
        currentPage: _currentPage,
        totalItems: _totalItems
      };
    }, error1 => this.errorScheduleMessage = error1);
  }
}
